import React, { useState } from 'react';
import { Modal } from 'antd';
import { useSelector } from 'react-redux';
import { useTranslation, Trans } from 'react-i18next';
import LanguageSelector from 'components/LanguageSelector';

export function Features() {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';

  // Modal state for the “Multilinguality” item
  const [isLangModalVisible, setLangModalVisible] = useState(false);
  const showLangModal = () => setLangModalVisible(true);
  const hideLangModal = () => setLangModalVisible(false);

  // Styles
  const contentStyle = {
    fontFamily: 'Roboto, sans-serif',
    fontWeight: 300,
    padding: 20,
    backgroundColor: 'white',
    lineHeight: 1.5,
    fontSize: 14,
    color: 'black',
    margin: 10,
    borderRadius: 10,
    direction: isRTL ? 'rtl' : 'ltr',
    textAlign: isRTL ? 'right' : 'left',
  };
  const listStyle = { listStyleType: 'none', paddingLeft: 20 };
  const listItemStyle = { marginBottom: 10 };
  const bulletStyle = { fontWeight: 'bold', color: '#0056b3' };

  // Data
  const indicatorsState = useSelector((s) => s.privateIndicators);
  const indicatorsArray = indicatorsState?.value
    ? Object.values(indicatorsState.value)
    : [];
  const nonPrivateCount = indicatorsArray.filter(i => i.is_private === 0).length;

  return (
    <div style={contentStyle}>
      <p>{t('features.intro')}</p>
      <ul style={listStyle}>
        {/* Multilinguality opens modal */}
        <li
          style={{ ...listItemStyle}}
        >
          <span style={bulletStyle}>
            {t('features.multilinguality.title')}:
          </span>{' '}
          {t('features.multilinguality.description')}
        </li>

        <li style={listItemStyle}>
          <span style={bulletStyle}>{t('features.accordionMenu.title')}:</span>{' '}
          {t('features.accordionMenu.description')}
        </li>

        <li style={listItemStyle}>
          <span style={bulletStyle}>{t('features.countryGroupings.title')}:</span>{' '}
          {t('features.countryGroupings.description')}
        </li>

        <li style={listItemStyle}>
          <span style={bulletStyle}>{t('features.quickAccess.title')}:</span>{' '}
          <span
            dangerouslySetInnerHTML={{
              __html: t('features.quickAccess.description')
            }}
          />
        </li>

        <li style={listItemStyle}>
          <span style={bulletStyle}>{t('features.browseSearch.title')}:</span>{' '}
          {t('features.browseSearch.description', { count: nonPrivateCount })}
        </li>

        <li style={listItemStyle}>
          <span style={bulletStyle}>{t('features.downloadByCategory.title')}:</span>{' '}
          {t('features.downloadByCategory.description')}
        </li>

        <li style={listItemStyle}>
          <span style={bulletStyle}>{t('features.multipleCategorisation.title')}:</span>{' '}
          {t('features.multipleCategorisation.description')}
        </li>

        <li style={listItemStyle}>
          <span style={bulletStyle}>{t('features.indicatorsDefinitions.title')}:</span>{' '}
          <span
            dangerouslySetInnerHTML={{
              __html: t('features.indicatorsDefinitions.description')
            }}
          />
        </li>

        <li style={listItemStyle}>
          <span style={bulletStyle}>{t('features.lastYearAvailableData.title')}:</span>{' '}
          {t('features.lastYearAvailableData.description')}
        </li>

        <li style={listItemStyle}>
          <span style={bulletStyle}>{t('features.previewDownload.title')}:</span>{' '}
          {t('features.previewDownload.description')}
        </li>
      </ul>

      {/* Modal for Multilinguality */}
      <Modal
        title={t('features.multilinguality.title')}
        visible={isLangModalVisible}
        onCancel={hideLangModal}
        footer={null}
      >
              <LanguageSelector />
      </Modal>
    </div>
  );
}
